import React, {Component} from 'react';
import {withTranslate} from 'react-redux-multilingual'
import FooterOne from "./common/footers/footer-one";
import Header from "./Header";


class App extends Component {

    render() {

        return (
            <div>
                <Header/>

                <div>
                    {this.props.children}
                </div>
                <FooterOne logoName={'logo.png'}/>
            </div>
        );
    }
}

export default withTranslate(App);
